<template>

    <div id="lt_lyrics">


        <h3 class="subtitle">קרדיטים</h3>
		<div v-html="cleanRichText(item.credits)"></div>


    </div>
</template>

<script>

export default {
  props: ["item"],
  data(){
    return {
    }
  },
  methods: {

  }
}
</script>